import React, { useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';
import { defaultSelectStyles, selectTheme } from './styles';

const AsyncSearchSelect = ({
  fetchOptions,
  className,
  placeholder,
  onChange,
  value,
  label,
  isDisabled,
  customStyles,
  errorMsg,
  isClearable = true,
  // The control's accessible name when it has no visible label (e.g. a filter shown by its placeholder).
  ariaLabel,
}) => {
  const [t] = useTranslation();
  const timerRef = useRef(null);

  const loadOptions = useCallback(
    (inputValue, callback) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(() => {
        fetchOptions(inputValue)
          .then((results) => {
            const options = results.map((item) => ({
              value: item.uuid,
              label: item.name,
            }));
            callback(options);
          })
          .catch(() => {
            callback([]);
          });
      }, 300);
    },
    [fetchOptions],
  );

  return (
    <div className={className}>
      {label && (
        <label className="mb-1 block text-sm font-medium text-slate-700">
          {label}
        </label>
      )}
      <AsyncSelect
        className="relative"
        styles={customStyles || defaultSelectStyles}
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        onChange={onChange}
        value={value}
        isDisabled={isDisabled}
        isClearable={isClearable}
        placeholder={placeholder ?? t('buttons.select')}
        aria-label={ariaLabel || label || undefined}
        noOptionsMessage={() => t('table.no_options')}
        loadingMessage={() => t('table.loading')}
        theme={selectTheme}
      />
      {errorMsg && (
        <span className="mt-1 text-xs font-semibold text-error">
          {errorMsg}
        </span>
      )}
    </div>
  );
};

export default AsyncSearchSelect;
